import { render } from "./CompanySelect.vue?vue&type=template&id=b24b1392&scoped=true"
import script from "./CompanySelect.vue?vue&type=script&lang=js"
export * from "./CompanySelect.vue?vue&type=script&lang=js"

import "./CompanySelect.vue?vue&type=style&index=0&id=b24b1392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24b1392"]])

export default __exports__